/* eslint-disable global-require */
const { en: common } = require("../../common");

module.exports = {
	...common,
	"how-to-buy": require("./how-to-buy-page.json"),
};
